import { gql } from '@apollo/client';

export const GET_NOTIFICATIONS = gql(/* GraphQL */ `
    query GetNotifications {
        getNotifications {
            id
            subject
            message
            read
            readAt
            sentAt
            metadata {
                requestId
            }
        }
    }
`);

export const GET_UNREAD_NOTIFICATION_COUNT = gql(/* GraphQL */ `
    query GetUnreadNotificationCount {
        getUnreadNotificationCount
    }
`);

export const MARK_NOTIFICATION_AS_READ = gql(/* GraphQL */ `
    mutation MarkNotificationAsRead($id: String!) {
        markNotificationAsRead(id: $id) {
            id
            readAt
            read
        }
    }
`);

export const DELETE_NOTIFICATION = gql(/* GraphQL */ `
    mutation DeleteNotification($id: String!) {
        deleteNotification(id: $id) {
            id
        }
    }
`);

export const DELETE_ALL_NOTIFICATIONS = gql(/* GraphQL */ `
    mutation DeleteAllNotifications {
        deleteAllNotifications {
            id
        }
    }
`);

export default MARK_NOTIFICATION_AS_READ;
